
import { Crosshair, Tooltip } from '@unovis/ts'
import { defineComponent } from 'vue'
import { XYRecord } from '~/utils/charts/unovis'
import { seriesByType } from '~/utils/charts/zchart'
import { buildLineSeriesComponents } from './lineSeries'
import ZChartBaseMixin from './zChartBaseMixin'

export default defineComponent({
  name: 'ZChartLine',
  mixins: [ZChartBaseMixin],
  methods: {
    buildChartComponents(x: (d: XYRecord) => number) {
      return this.createLineComponents(x)
    },
    createLineComponents(x: (d: XYRecord) => number) {
      return buildLineSeriesComponents({
        chartType: 'line',
        dataSets: this.dataSets,
        palette: this.palette,
        xyRecords: this.xyRecords,
        x,
        chartId: this.chartId
      })
    },
    createCrosshair(tooltip?: Tooltip | null) {
      const lineIndices = seriesByType('line', this.dataSets, 'line')
      const dataIndices = lineIndices.length ? lineIndices : this.dataSets.map((_, index) => index)
      const yAccessors = dataIndices.map((index) => (d: XYRecord) => d.values[index] ?? null)
      const crosshairColors = dataIndices.map((index) => this.palette[index] || this.palette[0])

      return new Crosshair<XYRecord>({
        x: (d: XYRecord) => d.x,
        y: yAccessors,
        snapToData: true,
        hideWhenFarFromPointer: false,
        color: crosshairColors,
        strokeColor: crosshairColors,
        strokeWidth: 2,
        tooltip: tooltip ?? undefined,
        template: (datum: XYRecord) => this.createCrosshairTemplate(datum)
      })
    },
    afterChartUpdate() {
      this.ensureLineAreaGradients('line')
    },
    afterContainerCreated() {
      this.ensureLineAreaGradients('line')
    }
  }
})
